import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var StaticPagesReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default StaticPagesReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/StaticPages/StaticPagesReduxProps.ts
// module id = 545
// module chunks = 0